import { render, staticRenderFns } from "./DingYangArticleNew.vue?vue&type=template&id=2278b729&scoped=true&"
import script from "./DingYangArticleNew.vue?vue&type=script&lang=js&"
export * from "./DingYangArticleNew.vue?vue&type=script&lang=js&"
import style0 from "./DingYangArticleNew.vue?vue&type=style&index=0&id=2278b729&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278b729",
  null
  
)

export default component.exports